import { FUNNEL_PAGES } from 'data/routes'
import type {
  FunnelRouteKey,
  FunnelsWithRoute,
  RouteDefinition,
} from 'types/routes'
import type { Funnel } from 'types/state'

export const getFunnelsWithRoute = <K extends FunnelRouteKey>(
  routeKey: K
): readonly FunnelsWithRoute<K>[] =>
  (Object.keys(FUNNEL_PAGES) as Funnel[]).filter(
    (funnel): funnel is FunnelsWithRoute<K> => routeKey in FUNNEL_PAGES[funnel]
  )

export const getFunnelsRoutePaths = <K extends FunnelRouteKey>(routeKey: K) => {
  return Object.values<Record<string, RouteDefinition>>(FUNNEL_PAGES).flatMap(
    (pages) => {
      return Object.entries(pages)
        .filter(([key]) => key === routeKey)
        .map(([, route]) => route.path)
    }
  )
}

export const withCurrentQuery = (path: string, currentPath: string) => {
  const queryString = currentPath.split('?')[1]
  return queryString ? `${path}?${queryString}` : path
}
